import React from 'react';
import { Tooltip, Card, Col , Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, WarningOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Paragraph, Text } = Typography;

export default function TaskBar({ event }) {
  const isCompleted = event.time > 0;
  let statusColor = '#52c41a'; // Green for success
  let statusIcon = <CheckCircleOutlined />;

  if (event.modifier === 'EXCEPTION') {
    statusColor = '#faad14'; // Orange for exceptions
    statusIcon = <WarningOutlined />;
  } else if (event.modifier === 'NOT_REQUIRED') {
    statusColor = '#52c41a'; // Gray for not required
    statusIcon = <InfoCircleOutlined />;
  } else if (!event.success) {
    statusColor = '#f5222d'; // Red for failure
    statusIcon = <CloseCircleOutlined />;
  } else if (isCompleted && event.order !== event.expectedOrder) {
    statusColor = '#1890ff'; // Blue for out of order
    statusIcon = <InfoCircleOutlined />;
  } 
  
  function renderCard (event) {
      return (
          <Col key={event.title} >
              <Tooltip title={`Expected Order: ${event.expectedOrder}, Actual Order: ${event.order}`}>
                  <Card
                      size="small"
                      style={{
                          height: '100%',
                          borderColor: statusColor,
                      }}
                      bodyStyle={{
                          padding: '12px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          height: '100%'
                      }}
                  >
                      <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          marginBottom: '8px'
                      }}>
                          {statusIcon}
                          {isCompleted && (
                              <Text strong style={{fontSize: '16px', color: statusColor}}>
                                  {event.order}
                              </Text>
                          )}
                      </div>
                      <Paragraph strong style={{marginBottom: '4px'}}>{event.title}</Paragraph>
                      <div>
                          <Text type="secondary" style={{fontSize: '12px'}}>
                              {event.time > 0 ? `${event.time.toFixed(2)}s` : 'Not Completed'}
                          </Text>
                      </div>
                  </Card>
              </Tooltip>
          </Col>
      );
  }

  return (
    <Tooltip
        titleStyle={{
            backgroundColor: '#fff',
        }}
      title={
        renderCard(event)
      }
    >
      <div
        style={{
          width: '20px',
          height: '20px',
          backgroundColor: isCompleted || event.modifier === 'NOT_REQUIRED' ? statusColor : '#f0f0f0',
          border: `1px solid ${statusColor}`,
          display: 'inline-block',
          margin: '0 2px',
          cursor: 'pointer',
          borderRadius: '6px',
        }}
      >
        {isCompleted && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            {statusIcon}
          </div>
        )}
      </div>
    </Tooltip>
  );
}